import * as angular from "angular";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { TalkingPointDataProvider } from "../../data-provider/talking-point.dp";

let TalkingPointListComponent = {
    selector: "vcTalkingPointList",
    templateUrl:
        "/angular/components/talking-point/talking-point-list.component.html",
    restrict: "EA",
    replace: true,
    bindings: {
        customize: "=?",
    },
    controller: class TalkingPointListController {
        public customize?: any;
        // ************************************

        private $scope: any;
        private dataProvider: TalkingPointDataProvider;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        public permissionProvider: PermissionCheck;
        public categories: Array<any> = [];
        public loading = true;
        public isLeaderView: boolean;

        constructor(
            $scope: any,
            __app_type: string,
            TalkingPointDataProvider: TalkingPointDataProvider,
            PermissionCheck: PermissionCheck,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.dataProvider = TalkingPointDataProvider;
            this.permissionProvider = PermissionCheck;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;

            this.isLeaderView = __app_type == "LEADER";
        }

        $onInit() {
            this.dataProvider.getCategories().then(
                (categories) => {
                    this.loading = false;
                    this.categories = categories;
                },
                () => {
                    this.loading = false;
                    this.toast.error(
                        "An error occurred while loading talking points."
                    );
                }
            );
        }

        openTalkingPointDialog(point, category, onlyTeam, ev) {
            this.dialog
                .show({
                    component: "vc-create-talking-point",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedPoint: point,
                        selectedCategory: category,
                        onlyTeam: onlyTeam,
                    },
                })
                .then((pointEdited) => {
                    this.dataProvider.updatePoint(pointEdited, point).then(
                        () => {
                            point.setData(pointEdited);
                            this.toast.success("Talking point updated");
                        },
                        () => this.toast.error()
                    );
                });
        }

        openDeletePointDialog(point, category, ev) {
            this.dialog
                .delete({
                    targetEvent: ev,
                    locals: {
                        bodyText: "They will be permanently deleted",
                        title: "Delete Talking Point?",
                    },
                })
                .then(() => {
                    this.dataProvider.deletePoint(point, category).then(
                        () => this.toast.success("Talking point deleted"),
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("talkingPoint")
    .component(TalkingPointListComponent.selector, TalkingPointListComponent);
